// PIN-related constants

// Maximum length of PIN code
export const MAX_PIN_LENGTH = 6;
export const MAX_PIN_ATTEMPTS = 4;